<div class="layout-column custom-panel full-width full-height">

  <span class="br-body-2 font-weight-400 primary-300 margin-top-10 padding-left-10 padding-right-10" translate>Today's Projects</span>

  <!--Search Box-->
  <div class="layout-row layout-align-start-center padding-top-10 padding-left-10 padding-right-10 padding-bottom-5">

    <app-bringoz-search-input class="flex"
                              [query]="queryString"
                              (queryChangeEvent)="onQueryChange($event)">

    </app-bringoz-search-input>

  </div>

  <hr class="main-divider">

  <div class="flex layout-column padding-10">
    <cdk-virtual-scroll-viewport [itemSize]="20" class="flex viewport">
      <div *cdkVirtualFor="let project of projectsCopy"
           [ngClass]="{'selected': project.id === selectedProjectId}"
           (click)="onSelect(project)"
           class="item layout-row layout-align-start-center text-ellipsis">

        <span class="br-body-2 font-weight-400 primary-300 flex text-ellipsis">
          {{ project.name }}
        </span>

      </div>
    </cdk-virtual-scroll-viewport>
  </div>

  <app-bringoz-linear-progress *ngIf="!!isFetchingData"></app-bringoz-linear-progress>

</div>
